import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfileFollowerIds = async ({ uid }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)

		// TODO: deletes - these subcollection queries need to be handled, do we just remove the collection (put it under deleted too)? rename it?
		const followersQuerySnap = await userProfileDocRef.collection('followers').get()

		return followersQuerySnap.docs.map(d => d.id)
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfileFollowerIds



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfileFollowerIds.js